<template>
  <div class="OATop">
    <div><ShowNavHead/></div>
    <div class="OATopLeft" style="width: 85%;">
      <div class="OAScreenInput">
        <div>服务中心</div>
        <el-select v-model="select" slot="prepend" placeholder="请选择" filterable>
          <el-option label="餐厅名" value="1"></el-option>
          <el-option label="订单号" value="2"></el-option>
          <el-option label="用户电话" value="3"></el-option>
        </el-select>
      </div>
      <div class="OAScreenInput">
        <div>项目名称</div>
        <el-select v-model="select" slot="prepend" placeholder="请选择" filterable>
          <el-option label="餐厅名" value="1"></el-option>
          <el-option label="订单号" value="2"></el-option>
          <el-option label="用户电话" value="3"></el-option>
        </el-select>
      </div>
      <div class="OAScreenInput">
        <div>服务状态</div>
        <el-select v-model="select" slot="prepend" placeholder="请选择" filterable>
          <el-option label="餐厅名" value="1"></el-option>
          <el-option label="订单号" value="2"></el-option>
          <el-option label="用户电话" value="3"></el-option>
        </el-select>
      </div>
    </div>
    <div>
      <button class="search" style="margin-right:20px;width:104px;" @click="syncOA">从OA中同步</button>
    </div>

    <el-dialog title="从OA中同步"  :visible.sync="dialogVisible" width="384px"  >
      <div>同步过程可能需要几分钟，请耐心等待</div>
      <span slot="footer" class="dialog-footer">
        <button class="clear" @click="dialogVisible = false">取消</button>
        <button
          class="search"
          @click="confirmSync"
          style="margin-left:10px;font-weight:600"
          type="primary"
          v-loading.fullscreen.lock="fullscreenLoading"
          element-loading-text="同步中"
        >立即同步</button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible6" width="480px" >
        <div style="height:1px"></div>
        <div class="successBox">
          <div class="successImg"><img src="./../../../assets/employee/images/success.png"></div>
          <div class="successText" style="height:25px">同步成功</div>
          <div class="importNum" style="height:25px">新增3条客户信息</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible6 = false">完成</button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="dialogVisible7" width="480px" >
        <div style="height:1px"></div>
        <div class="successBox">
          <div class="successImg"><img src="./../../../assets/employee/images/failed.png"></div>
          <div class="successText" style="height:25px">同步失败</div>
          <div class="importNum" style="height:25px">中断原因：网络异常</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="dialogVisible7 = false">关闭</button>
          <button
            class="search"
            @click="dialogVisible7 = false"
            style="margin-left:10px;font-weight:600"
          >重新同步</button>
        </span>
      </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      fullscreenLoading: false,
      select: "",
      //同步OA
      dialogVisible:false,
      //同步失败
      dialogVisible7:false,
      //同步成功
      dialogVisible6:false
    };
  },
  methods: {
    
    syncOA(){
      this.dialogVisible = true;
    },
    confirmSync(){
       this.fullscreenLoading = true;
        setTimeout(() => {
          this.fullscreenLoading = false;
           this.dialogVisible7=true;
        }, 2000);
      this.dialogVisible = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.OAScreenInput .el-input__inner {
  height: 32px;
  line-height: 32px;
  width: 180px;
  margin-left: 10px;
  /* margin-top: 10px; */
}
.OAScreenInput .el-input__icon {
  /* margin-top: 10px; */
  height: 32px;
  line-height: 32px;
}
.screenAndExport .el-button {
  padding: 0;
  margin-right: 20px;
}
.OATop .el-dialog__body{
  padding: 0 20px;
}
.OATop .el-dialog__header{
  padding: 0 20px;
}
.OATop .el-dialog__footer{
  padding: 0 20px;
}
</style>
